export const ucfirst = (text: string) => {
  if (text === '' || text === undefined) {
    return '';
  }
  return text[0].toUpperCase() + text.substring(1).toLowerCase();
};
